var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconZoomToFitDarkBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.618,
    height: 26.618,
    viewBox: "0 0 26.618 26.618",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M.545,58.41l-.336-.336a.713.713,0,0,1,0-1.008l9.855-9.855H6.417A.713.713,0,0,1,5.7,46.5v-.475a.713.713,0,0,1,.713-.713h5.942a.951.951,0,0,1,.951.951V52.2a.713.713,0,0,1-.713.713h-.475a.713.713,0,0,1-.713-.713V48.555L1.554,58.41A.713.713,0,0,1,.545,58.41ZM14.26,45.31H20.2a.713.713,0,0,0,.713-.713v-.475a.713.713,0,0,0-.713-.713H16.555l9.855-9.855a.713.713,0,0,0,0-1.008l-.336-.336a.713.713,0,0,0-1.008,0l-9.855,9.855V38.417A.713.713,0,0,0,14.5,37.7h-.475a.713.713,0,0,0-.713.713v5.942A.951.951,0,0,0,14.26,45.31Z",
    transform: "translate(0 -32)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconZoomToFitDarkBlue);
export default __webpack_public_path__ + "static/media/Icon-ZoomToFit-DarkBlue.5cdd6182df574820d99adc9fe6c84252.svg";
export { ForwardRef as ReactComponent };